import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  constructor(private toast: ToastrService) {}

  successToast(message: string) {
    this.toast.success(message);
  }
  errorToast(
    message: string,
    timeOut: number = 5000, // How long the toast stays visible (in ms)
    tapToDismiss: boolean = true // If true, toast closes when clicking outside
  ) {
    this.toast.error(message, '', {
      timeOut: timeOut,
      tapToDismiss: tapToDismiss,
    });
  }

  warningToast(message: string) {
    this.toast.warning(message);
  }

  infoToast(message: string) {
    this.toast.info(message);
  }

  errorToast2(message: string) {
    this.toast.error(message, '', {
      timeOut: 2000,
    });
  }
}
